import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const DETAILS_FIELD_SKELETONS_COUNT = 4;
const LINE_ITEM_SKELETONS_COUNT = 3;
const TOTAL_SKELETONS_COUNT = 3;

/** Mirrors the bill details fields, line-item table, and totals while the snapshot loads. */
export function BillDetailsSkeleton() {
  return (
    <div className="grid w-full max-w-screen-2xl grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_340px]">
      <div className="flex flex-col gap-6">
        <Card>
          <CardHeader>
            <Skeleton className="h-5 w-44" />
          </CardHeader>
          <CardContent className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: DETAILS_FIELD_SKELETONS_COUNT }).map((_, index) => (
              <div key={index} className="space-y-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-10 w-full" />
              </div>
            ))}
          </CardContent>
        </Card>
        <Card className="overflow-hidden">
          <CardHeader>
            <Skeleton className="h-5 w-28" />
          </CardHeader>
          <div className="space-y-px border-y bg-border">
            {Array.from({ length: LINE_ITEM_SKELETONS_COUNT }).map((_, index) => (
              <div
                key={index}
                className="grid min-w-[980px] grid-cols-[minmax(12rem,1fr)_10rem_10rem_14rem_10rem] gap-4 bg-card px-6 py-3"
              >
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-5 w-full self-center" />
              </div>
            ))}
          </div>
        </Card>
      </div>
      <Card className="h-fit">
        <CardHeader>
          <Skeleton className="h-5 w-20" />
        </CardHeader>
        <CardContent className="space-y-4">
          {Array.from({ length: TOTAL_SKELETONS_COUNT }).map((_, index) => (
            <Skeleton key={index} className="h-5 w-full" />
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
